const FLASH_PREFIX = 'flash_'

const SessionService = {

    setItem(key, value) {
        sessionStorage.setItem(key, JSON.stringify(value))
    },

    getItem(key, defaultValue = null) {
        let value = sessionStorage.getItem(key)

        if (value === null) {
            return defaultValue
        }

        try {
            value = JSON.parse(value)
        } catch(err) {
            value = defaultValue
        }

        return value
    },

    removeItem(key) {
        sessionStorage.removeItem(key)
    },

    clear() {
        sessionStorage.clear()
    },

    removeAllItems(prefix = null) {
        if (!prefix) {
            this.clear()
            return
        }

        let keys = Object.keys(sessionStorage).filter(function(key) {
            return key.startsWith(prefix)
        })

        keys.forEach(function(key) {
            this.removeItem(key)
        })
    },

    setFlash(key, value = true) {
        this.setItem(FLASH_PREFIX + key, value)
    },

    getFlash(key, defaultValue = null) {
        let value = this.getItem(FLASH_PREFIX + key, defaultValue)
        this.removeFlash(key)
        return value
    },

    hasFlash(key) {
        return Object.keys(sessionStorage).includes(FLASH_PREFIX + key)
    },

    removeFlash(key) {
        this.removeItem(FLASH_PREFIX + key)
    },

    removeAllFlashes() {
        let keys = Object.keys(sessionStorage).filter(function(key) {
            return key.startsWith(FLASH_PREFIX)
        })

        keys.forEach(function(key) {
            this.removeItem(key)
        })
    },

}

export default SessionService
